import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bomwise-footer mt-5 py-4">
      <Container>
        <Row>
          <Col>
            <h5>BOMWise</h5>
            <p className="small">
              Do work
            </p>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="text-center small">
            © {new Date().getFullYear()} BOMWise. All rights reserved.
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;